module.exports = __webpack_public_path__ + "static/media/main.20e2d5d8.png";